import type {
    AssignRolePermissionPayload,
    AssignRolePermissionResponse,
} from '@/types/apps/assign-role-permission.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';
import type { Indexable } from '@/types/service/indexable.interface';

type AssignRolePermissionListResponse = ApiResponse<
    PaginatedResult<AssignRolePermissionResponse>
>;

export class AssignRolePermissionService
    implements
        Indexable<AssignRolePermissionListResponse>,
        Creatable<ApiResponse<AssignRolePermissionListResponse>>
{
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/admin/assign-role-permission',
    };

    public index(
        params?: QueryParams
    ): Promise<AssignRolePermissionListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }

    public create(
        payload: AssignRolePermissionPayload
    ): Promise<ApiResponse<AssignRolePermissionListResponse>> {
        return this.apiClient.postApi(this.endpoints.base(), payload);
    }
}
